import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { simulateAnalysis } from '../services/staticAnalysis';
import Header from '../components/Header';
import '../App.css';

const ConsejosSabios = () => {
  const [selectedCategory, setSelectedCategory] = useState('estrategia');
  const [modalContent, setModalContent] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Datos de los sabios y sus consejos
  const sabiosData = {
    estrategia: [
      {
        id: 'sun_tzu',
        nombre: 'Sun Tzu',
        periodo: '544-496 a.C.',
        titulo: 'El Arte de la Guerra',
        avatar: '🎯',
        consejos: [
          {
            texto: "La suprema excelencia consiste en quebrar la resistencia del enemigo sin luchar.",
            contexto: "Sobre la estrategia indirecta y la diplomacia como arma superior a la guerra."
          },
          {
            texto: "Si conoces al enemigo y te conoces a ti mismo, no debes temer el resultado de cien batallas.",
            contexto: "La importancia de la inteligencia y el autoconocimiento en la estrategia."
          },
          {
            texto: "Toda guerra se basa en el engaño. Por lo tanto, cuando seas capaz de atacar, simula incapacidad.",
            contexto: "El arte de la desinformación estratégica y la sorpresa táctica."
          }
        ]
      },
      {
        id: 'clausewitz',
        nombre: 'Carl von Clausewitz',
        periodo: '1780-1831',
        titulo: 'De la Guerra',
        avatar: '⚔️',
        consejos: [
          {
            texto: "La guerra es la continuación de la política por otros medios.",
            contexto: "La guerra nunca debe ser un fin en sí mismo, sino un instrumento político."
          },
          {
            texto: "En la guerra, todo es muy simple, pero lo más simple es difícil.",
            contexto: "La fricción y la complejidad inherente de las operaciones militares."
          },
          {
            texto: "El primer acto de juicio del comandante es determinar el tipo de guerra en la que se embarca.",
            contexto: "La importancia de entender la naturaleza del conflicto antes de actuar."
          }
        ]
      },
      {
        id: 'napoleon',
        nombre: 'Napoleón Bonaparte',
        periodo: '1769-1821',
        titulo: 'Emperador y Estratega',
        avatar: '👑',
        consejos: [
          {
            texto: "Un ejército marcha sobre su estómago.",
            contexto: "La logística es más importante que la táctica brillante."
          },
          {
            texto: "Nunca interrumpas a tu enemigo cuando esté cometiendo un error.",
            contexto: "La paciencia estratégica y el aprovechamiento de errores ajenos."
          },
          {
            texto: "La moral es a lo físico como tres es a uno.",
            contexto: "El factor psicológico es decisivo en el combate y la política."
          }
        ]
      }
    ],
    geopolitica: [
      {
        id: 'mackinder',
        nombre: 'Halford Mackinder',
        periodo: '1861-1947',
        titulo: 'El Pivote Geográfico',
        avatar: '🌍',
        consejos: [
          {
            texto: "Quien gobierne Europa del Este dominará el Heartland; quien gobierne el Heartland dominará la Isla Mundial; quien gobierne la Isla Mundial dominará el mundo.",
            contexto: "La teoría del Heartland y la importancia geopolítica de Eurasia."
          },
          {
            texto: "La geografía es el factor más permanente en la política.",
            contexto: "Las características físicas del territorio determinan las posibilidades estratégicas."
          },
          {
            texto: "El poder marítimo y el poder terrestre están en eterna competencia.",
            contexto: "La tensión fundamental entre potencias navales y continentales."
          }
        ]
      },
      {
        id: 'spykman',
        nombre: 'Nicholas Spykman',
        periodo: '1893-1943',
        titulo: 'Teoría del Rimland',
        avatar: '🗺️',
        consejos: [
          {
            texto: "Quien controle el Rimland dominará Eurasia; quien domine Eurasia controlará los destinos del mundo.",
            contexto: "La importancia de las zonas costeras de Eurasia frente al Heartland."
          },
          {
            texto: "La geografía no cambia, pero las relaciones geográficas sí.",
            contexto: "La tecnología modifica el valor estratégico de las posiciones geográficas."
          },
          {
            texto: "El poder es la capacidad de dirigir las acciones de otros para promover los propios fines.",
            contexto: "Definición práctica del poder en las relaciones internacionales."
          }
        ]
      },
      {
        id: 'mahan',
        nombre: 'Alfred Thayer Mahan',
        periodo: '1840-1914',
        titulo: 'Influencia del Poder Naval',
        avatar: '⚓',
        consejos: [
          {
            texto: "El mar es un gran bien común, y quien lo controla, controla el comercio mundial.",
            contexto: "La importancia del poder naval para la prosperidad económica."
          },
          {
            texto: "Una flota sin bases es como un ave sin nido.",
            contexto: "La necesidad de puntos de apoyo estratégicos para proyectar poder naval."
          },
          {
            texto: "El control del mar significa el control de las comunicaciones mundiales.",
            contexto: "Las líneas de comunicación marítima como arterias del poder global."
          }
        ]
      }
    ],
    diplomacia: [
      {
        id: 'bismarck',
        nombre: 'Otto von Bismarck',
        periodo: '1815-1898',
        titulo: 'El Canciller de Hierro',
        avatar: '🎭',
        consejos: [
          {
            texto: "La política es el arte de lo posible, lo alcanzable, el arte de lo siguiente mejor.",
            contexto: "El realismo político y la búsqueda de soluciones pragmáticas."
          },
          {
            texto: "Nunca luches con rusos. En cada truco que inventes, ellos responderán con una estupidez impredecible.",
            contexto: "La importancia de entender la mentalidad y cultura de otros actores."
          },
          {
            texto: "Un tratado sin espada no es más que palabras.",
            contexto: "La diplomacia debe estar respaldada por la fuerza para ser efectiva."
          }
        ]
      },
      {
        id: 'metternich',
        nombre: 'Klemens von Metternich',
        periodo: '1773-1859',
        titulo: 'Arquitecto del Equilibrio',
        avatar: '⚖️',
        consejos: [
          {
            texto: "El equilibrio de poder es la condición fundamental de la paz.",
            contexto: "La estabilidad internacional requiere que ninguna potencia domine completamente."
          },
          {
            texto: "Los tratados son como las rosas y las jóvenes: duran mientras duran.",
            contexto: "La naturaleza temporal de los acuerdos internacionales."
          },
          {
            texto: "El secreto de la política está en hacer un buen tratado con el tiempo.",
            contexto: "La paciencia y el timing en la diplomacia internacional."
          }
        ]
      },
      {
        id: 'kissinger',
        nombre: 'Henry Kissinger',
        periodo: '1923-2023',
        titulo: 'Realismo Moderno',
        avatar: '🕴️',
        consejos: [
          {
            texto: "El poder sin legitimidad es tiranía; la legitimidad sin poder es irrelevante.",
            contexto: "La necesidad de combinar fuerza real con aceptación internacional."
          },
          {
            texto: "La estabilidad internacional requiere un equilibrio entre poder y legitimidad.",
            contexto: "Los sistemas internacionales duraderos combinan realismo y consenso."
          },
          {
            texto: "El dilema del estadista es actuar sobre la base de evaluaciones que no pueden ser probadas en el momento de la decisión.",
            contexto: "La incertidumbre inherente en la toma de decisiones estratégicas."
          }
        ]
      }
    ],
    economia: [
      {
        id: 'smith',
        nombre: 'Adam Smith',
        periodo: '1723-1790',
        titulo: 'La Riqueza de las Naciones',
        avatar: '💰',
        consejos: [
          {
            texto: "No es de la benevolencia del carnicero, del cervecero o del panadero que esperamos nuestra cena, sino de su consideración hacia su propio interés.",
            contexto: "El interés propio como motor de la prosperidad económica."
          },
          {
            texto: "La mano invisible del mercado guía a los individuos hacia el bien común.",
            contexto: "Los mercados libres como mecanismo de coordinación social."
          },
          {
            texto: "Las naciones, como los individuos, se enriquecen especializándose en lo que hacen mejor.",
            contexto: "La ventaja comparativa y la división internacional del trabajo."
          }
        ]
      },
      {
        id: 'keynes',
        nombre: 'John Maynard Keynes',
        periodo: '1883-1946',
        titulo: 'Teoría General',
        avatar: '📈',
        consejos: [
          {
            texto: "Los mercados pueden permanecer irracionales más tiempo del que tú puedes permanecer solvente.",
            contexto: "La importancia de la psicología y las expectativas en los mercados."
          },
          {
            texto: "A largo plazo, todos estaremos muertos.",
            contexto: "La necesidad de políticas económicas que funcionen en el corto plazo."
          },
          {
            texto: "Las ideas de los economistas y filósofos políticos, tanto cuando son correctas como cuando están equivocadas, son más poderosas de lo que comúnmente se cree.",
            contexto: "El poder de las ideas en la configuración de la realidad económica."
          }
        ]
      }
    ]
  };

  const categorias = [
    { id: 'estrategia', nombre: 'Estrategia Militar', icon: '⚔️' },
    { id: 'geopolitica', nombre: 'Geopolítica', icon: '🌍' },
    { id: 'diplomacia', nombre: 'Diplomacia', icon: '🤝' },
    { id: 'economia', nombre: 'Economía Política', icon: '💰' }
  ];

  const handleAnalyzeConsejo = async (sabio, consejo) => {
    setIsLoading(true);
    setIsModalOpen(true);
    setModalContent('Analizando sabiduría con IA...');

    try {
      const systemPrompt = `Actúa como un analista de pensamiento estratégico y geopolítico. Analiza el siguiente consejo de un gran pensador.
        
        Pensador: ${sabio.nombre} (${sabio.periodo})
        Obra principal: ${sabio.titulo}
        Consejo: "${consejo.texto}"
        Contexto histórico: "${consejo.contexto}"
        
        Proporciona un análisis de 4 puntos:
        1. **Significado Profundo**: ¿Qué principio universal revela este consejo?
        2. **Aplicación Moderna**: ¿Cómo se aplica este principio en el mundo actual?
        3. **Casos Históricos**: ¿Qué ejemplos históricos validan o contradicen este consejo?
        4. **Lecciones Prácticas**: ¿Qué pueden aprender los líderes modernos de esto?
        
        Mantén un tono académico pero accesible. Usa Markdown para formato.`;

      const userQuery = `Analiza el consejo: "${consejo.texto}" de ${sabio.nombre}`;
      const response = await simulateAnalysis("general", sabio.nombre);
      setModalContent(response);
    } catch (error) {
      console.error('Error analyzing consejo:', error);
      setModalContent(`**Error de Análisis:** No se pudo conectar con el sistema de inteligencia.\n\n*${error.message || "Verifique la configuración."}*`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a' }}>
      <Header />
      
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
        <div style={{ marginBottom: '1rem' }}>
          <Link to="/">
            <button style={{
              padding: '0.5rem 1rem',
              borderRadius: '0.5rem',
              border: '1px solid rgba(148, 163, 184, 0.3)',
              background: 'rgba(30, 41, 59, 0.8)',
              color: '#cbd5e1',
              cursor: 'pointer',
              fontSize: '0.9rem'
            }}>
              ← Volver al Inicio
            </button>
          </Link>
        </div>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: 'bold', 
            marginBottom: '1rem',
            color: '#f1f5f9',
            background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            📚 Consejos de los Sabios
          </h1>
          <h2 style={{ 
            fontSize: '1.5rem', 
            color: '#94a3b8',
            marginBottom: '1rem'
          }}>
            Sabiduría Estratégica de los Grandes Pensadores
          </h2>
          <p style={{ color: '#64748b', fontSize: '1.1rem' }}>
            Consejos atemporales de maestros de la estrategia, geopolítica y diplomacia
          </p>
        </div>

        {/* Categorías */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          marginBottom: '3rem',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          {categorias.map(categoria => (
            <button
              key={categoria.id}
              onClick={() => setSelectedCategory(categoria.id)}
              style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '0.5rem',
                border: 'none',
                background: selectedCategory === categoria.id 
                  ? 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)'
                  : 'rgba(30, 41, 59, 0.8)',
                color: selectedCategory === categoria.id ? '#0f172a' : '#cbd5e1',
                cursor: 'pointer',
                fontWeight: selectedCategory === categoria.id ? 'bold' : 'normal',
                transition: 'all 0.3s ease',
                fontSize: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <span>{categoria.icon}</span>
              {categoria.nombre}
            </button>
          ))}
        </div>

        {/* Sabios y Consejos */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
          gap: '2rem' 
        }}>
          {sabiosData[selectedCategory]?.map((sabio, index) => (
            <div key={sabio.id} style={{
              background: 'rgba(30, 41, 59, 0.8)',
              borderRadius: '1rem',
              border: '1px solid rgba(148, 163, 184, 0.2)',
              padding: '2rem',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.borderColor = '#fbbf24';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.2)';
            }}>
              
              {/* Header del Sabio */}
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                <span style={{ fontSize: '3rem', marginRight: '1rem' }}>{sabio.avatar}</span>
                <div>
                  <h3 style={{ color: '#f1f5f9', fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>
                    {sabio.nombre}
                  </h3>
                  <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '0.25rem' }}>
                    {sabio.periodo}
                  </p>
                  <p style={{ color: '#fbbf24', fontSize: '0.8rem', fontStyle: 'italic' }}>
                    {sabio.titulo}
                  </p>
                </div>
              </div>
              
              {/* Consejos */}
              <div style={{ space: '1rem' }}>
                {sabio.consejos.map((consejo, idx) => (
                  <div key={idx} style={{
                    background: 'rgba(15, 23, 42, 0.8)',
                    borderRadius: '0.5rem',
                    padding: '1.5rem',
                    marginBottom: '1rem',
                    border: '1px solid rgba(148, 163, 184, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => handleAnalyzeConsejo(sabio, consejo)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#3b82f6';
                    e.currentTarget.style.transform = 'scale(1.02)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(148, 163, 184, 0.1)';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}>
                    
                    <blockquote style={{ 
                      color: '#cbd5e1', 
                      fontSize: '1.1rem', 
                      fontStyle: 'italic',
                      marginBottom: '1rem',
                      lineHeight: '1.6',
                      borderLeft: '3px solid #fbbf24',
                      paddingLeft: '1rem'
                    }}>
                      "{consejo.texto}"
                    </blockquote>
                    
                    <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '1rem' }}>
                      {consejo.contexto}
                    </p>
                    
                    <div style={{ 
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0.5rem',
                      background: 'rgba(59, 130, 246, 0.2)',
                      borderRadius: '0.25rem'
                    }}>
                      <span style={{ color: '#93c5fd', fontSize: '0.9rem' }}>
                        🤖 Click para análisis profundo con IA
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Navigation */}
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          marginTop: '3rem', 
          padding: '2rem',
          background: 'rgba(30, 41, 59, 0.5)',
          borderRadius: '1rem',
          border: '1px solid rgba(148, 163, 184, 0.2)'
        }}>
          <Link to="/">
            <button style={{
              padding: '0.75rem 1.5rem',
              borderRadius: '0.5rem',
              border: 'none',
              background: 'rgba(148, 163, 184, 0.2)',
              color: '#cbd5e1',
              cursor: 'pointer',
              fontSize: '1rem'
            }}>
              ← Volver al Dashboard
            </button>
          </Link>
        </div>
      </div>

      {/* Modal para análisis IA */}
      {isModalOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '2rem'
        }}>
          <div style={{
            background: '#1e293b',
            borderRadius: '1rem',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            maxWidth: '900px',
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            position: 'relative'
          }}>
            <div style={{
              padding: '2rem',
              borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}>
              <h3 style={{ color: '#f1f5f9', fontSize: '1.5rem' }}>
                📚 Análisis de Sabiduría Estratégica
              </h3>
              <button
                onClick={() => setIsModalOpen(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#94a3b8',
                  fontSize: '1.5rem',
                  cursor: 'pointer'
                }}
              >
                ✕
              </button>
            </div>
            
            <div style={{ padding: '2rem' }}>
              {isLoading ? (
                <div style={{ textAlign: 'center', color: '#94a3b8' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🤖</div>
                  <p>Analizando sabiduría estratégica...</p>
                  <div style={{ 
                    width: '100%', 
                    height: '4px', 
                    background: 'rgba(148, 163, 184, 0.2)', 
                    borderRadius: '2px',
                    marginTop: '1rem',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      width: '30%',
                      height: '100%',
                      background: 'linear-gradient(90deg, #fbbf24, #f59e0b)',
                      borderRadius: '2px',
                      animation: 'loading 2s ease-in-out infinite'
                    }} />
                  </div>
                </div>
              ) : (
                <div 
                  style={{ 
                    color: '#cbd5e1',
                    lineHeight: '1.8',
                    fontSize: '1.1rem'
                  }}
                  dangerouslySetInnerHTML={{ 
                    __html: modalContent
                      .replace(/\*\*(.*?)\*\*/g, '<strong style="color: #f1f5f9; font-weight: bold;">$1</strong>')
                      .replace(/\*(.*?)\*/g, '<em style="color: #fbbf24;">$1</em>')
                      .replace(/\n\n/g, '</p><p style="margin: 1.5rem 0;">')
                      .replace(/^/, '<p style="margin: 1.5rem 0;">')
                      .replace(/$/, '</p>')
                      .replace(/(\d+\.\s)/g, '<br/><strong style="color: #fbbf24;">$1</strong>')
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsejosSabios;